// extracted by mini-css-extract-plugin
export var banner = "_1t-0";
export var icon = "_1t-1";
export var message = "_1t-2";